import { TechnicalConfigGroupTable } from "features/shared/components/technical-config-tab/TechnicalConfigGroupTable";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { WindowTypeGroup } from "../model/types";

import { getWindowGroupTableHeaders } from "../lib/windowGroupTableHeaders";

type WindowGroupTableProps = {
  groups: WindowTypeGroup[];
  isLoading: boolean;
  onConfigure: (group: WindowTypeGroup) => void;
  onDelete: (group: WindowTypeGroup) => void;
};

export const WindowGroupTable = ({ groups, isLoading, onConfigure, onDelete }: WindowGroupTableProps) => {
  const { t } = useTranslation();

  const headers = useMemo(() => getWindowGroupTableHeaders({ onConfigure, t }), [onConfigure, t]);

  return (
    <TechnicalConfigGroupTable
      columnsMinWidth="10rem"
      groups={groups}
      headers={headers}
      idColumnName="userDefinedType"
      isLoading={isLoading}
      onDelete={onDelete}
      rowRemoveable={(row) => row.hasTechnology}
    />
  );
};
